export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  width: '400px',
  height: '560px',
  minHeight: 0,
  overflow: 'hidden',
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 16px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.light}`,
  flexShrink: 0,
};

export const headerTitleStyles = {
  color: ({ palette }) => palette.text.primary,
};

export const headerActionsStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
};

export const toolbarStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '10px 12px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.light}`,
  flexShrink: 0,
};

export const searchInputStyles = {
  width: '100%',
};

export const tabsRowStyles = {
  display: 'flex',
  alignItems: 'center',
  '& > .MuiToggleButtonGroup-root': {
    marginBottom: 0,
  },
};

export const bodyStyles = {
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
};

export const emptyStyles = {
  padding: '32px 16px',
  textAlign: 'center',
  color: ({ palette }) => palette.text.secondary,
};

export const sectionHeaderStyles = {
  padding: '10px 16px 4px',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
  color: ({ palette }) => palette.text.secondary,
  backgroundColor: ({ palette }) => palette.background.secondary,
};

export const rowActionButtonStyles = {
  color: ({ palette }) => palette.text.secondary,
  opacity: 0,
  transition: 'opacity 120ms ease',
  '[role="button"]:hover &': {
    opacity: 1,
  },
};

export const rowActionButtonActiveStyles = {
  ...rowActionButtonStyles,
  opacity: 1,
  color: ({ palette }) => palette.primary.main,
};

export const notificationsButtonStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const notificationsButtonActiveStyles = {
  color: ({ palette }) => palette.primary.main,
};

export const viewAllRowStyles = {
  display: 'flex',
  justifyContent: 'center',
  padding: '12px 16px',
  borderTop: ({ palette }) => `1px solid ${palette.border.light}`,
  marginTop: 'auto',
};

export const viewAllButtonStyles = {
  width: '100%',
  justifyContent: 'center',
};

export const emptyTitleStyles = {
  color: ({ palette }) => palette.text.primary,
  marginBottom: '4px',
};

export const emptySubtitleStyles = {
  color: ({ palette }) => palette.text.secondary,
};
